module.exports = __webpack_public_path__ + "static/media/tokyo-map.39a7baab.png";